import { Subscribe } from 'unstated';

import NewTabIcon from '~/components/icons/NewTabIcon';
import ConnectorsContainer from '~/containers/Connectors';

import styles from './index.style';

function SalesforceObjectLink({ id, classes }) {
  return (
    <Subscribe to={[ConnectorsContainer]}>
      {(connectorsContainer) => {
        const connector = connectorsContainer.activeSalesforceConnector();

        if (!connector || !connector.instance_url) {
          return null;
        }

        const url = `${connector.instance_url}/${id}`;

        return (
          <a
            href={url}
            rel="noopener noreferrer"
            target="_blank"
            className={classes.container}>
            <span className={classes.title}>View on Salesforce</span>
            <NewTabIcon width={12} height={12} />
          </a>
        );
      }}
    </Subscribe>
  );
}

SalesforceObjectLink.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SalesforceObjectLink);
